<template>
    <div class="app-crop-modal">
        <div class="crop-modal-inner">
            <div class="crop-modal-body">
                <div class="crop-modal-close" @click="close"></div>
                <div class="crop-modal-text">{{ text }}</div>
                <cropper
                    class="cropper"
                    :canvas="true"
                    :stencil-props="{
                aspectRatio: aspectRatio ? aspectRatio : null
            }"
                    :src="img"
                    v-bind="$attrs"
                    v-if="img"
                    @change="change"
                ></cropper>
                <button class="crop-modal-finish" @click="crop">
                    {{ $trans("event.crop.save") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
    emits: ["close", "crop", "change"],
    components: { Cropper },
    inheritAttrs: false,
    props: {
        image: {
            type: String
        },
        text: {
            type: String
        },
        aspectRatio: {
            type: Number
        }
    },
    data() {
        return {
            img: this.image,
            data: null
        };
    },
    methods: {
        close() {
            this.$emit("close");
            this.img = false;
        },
        change(data) {
            this.data = data;
            this.$emit("change", this.data);
        },
        crop() {
            this.$emit("crop", this.data);
        }
    }
};
</script>
<style lang="scss" scoped>
.app-crop-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999999;

    .crop-modal-inner {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .crop-modal-body {
            position: relative;
            margin: 0 15px;
            background-color: #fff;
            border-radius: 5px;
            padding: 30px 30px 15px 30px;
            max-width: 575px;
            width: 100%;
            min-height: 415px;
            display: flex;
            flex-direction: column;
            overflow-y: auto; // Allow scrolling when content overflows
            max-height: 90vh; // Constrain the modal height to the viewport

            .cropper {
                margin: auto;
            }

            .crop-modal-finish {
                width: 150px;
                margin: 15px auto 0;
                border-radius: 0;
                background-color: #5c00b1;
                color: #fff;
                outline: none;
                border: none;
            }

            .crop-modal-close {
                position: absolute;
                top: 10px;
                left: 10px;
                background-size: contain;
                background-repeat: no-repeat;
                cursor: pointer;
                width: 15px;
                height: 15px;
                background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGhlaWdodD0iNTEycHgiIGlkPSJMYXllcl8xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgd2lkdGg9IjUxMnB4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48cGF0aCBkPSJNNDQzLjYsMzg3LjFMMzEyLjQsMjU1LjRsMTMxLjUtMTMwYzUuNC01LjQsNS40LTE0LjIsMC0xOS42bC0zNy40LTM3LjZjLTIuNi0yLjYtNi4xLTQtOS44LTRjLTMuNywwLTcuMiwxLjUtOS44LDQgIEwyNTYsMTk3LjhMMTI0LjksNjguM2MtMi42LTIuNi02LjEtNC05LjgtNGMtMy43LDAtNy4yLDEuNS05LjgsNEw2OCwxMDUuOWMtNS40LDUuNC01LjQsMTQuMiwwLDE5LjZsMTMxLjUsMTMwTDY4LjQsMzg3LjEgIGMtMi42LDIuNi00LjEsNi4xLTQuMSw5LjhjMCwzLjcsMS40LDcuMiw0LjEsOS44bDM3LjQsMzcuNmMyLjcsMi43LDYuMiw0LjEsOS44LDQuMWMzLjUsMCw3LjEtMS4zLDkuOC00LjFMMjU2LDMxMy4xbDEzMC43LDEzMS4xICBjMi43LDIuNyw2LjIsNC4xLDkuOCw0LjFjMy41LDAsNy4xLTEuMyw5LjgtNC4xbDM3LjQtMzcuNmMyLjYtMi42LDQuMS02LjEsNC4xLTkuOEM0NDcuNywzOTMuMiw0NDYuMiwzODkuNyw0NDMuNiwzODcuMXoiLz48L3N2Zz4=");
            }

            .crop-modal-text {
                font-weight: bold;
                margin-bottom: 15px;
            }
        }
    }
}
</style>
